import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/(public)/news/CookieSetter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/(public)/news/Item.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/data-dashboard/app/[locale]/(public)/news/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/app/[locale]/(public)/news/SignInButtons.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/data-dashboard/assets/images/bg-logo-pattern.png");
;
import(/* webpackMode: "eager" */ "/app/apps/data-dashboard/assets/images/mercedes-benz-data-dashboard-logo-wortmarke.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/components/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/data-dashboard/components/InlineLanguageSwitch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.11.1_next@14.2.28_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+_7bd7199a81a0d41372759ce15c1c4150/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@3.11.1_next@14.2.28_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+_7bd7199a81a0d41372759ce15c1c4150/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.26.10_@opentelemetry+api@1.9.0_@playwright+test@1.50.1_react_a2d4e7f0c6d992818776211a6e7b04e2/node_modules/next/dist/client/image-component.js");
